
import { motion } from 'framer-motion';
import { Bell, CalendarDays, Hospital, UserPlus } from 'lucide-react';
import { Link } from 'react-router-dom';
import Gradient from '@/assets/medihub_gradient_mesh.jpg';

const HealthProfessionalCTA = () => {
  return <section className="py-16 px-4 relative overflow-hidden">
    <div className="absolute inset-0 z-0">
      <img
        src={Gradient}
        alt="MediHub gradient háttér"
        className="w-full h-full object-cover"
      />
    </div>

    <div className="container mx-auto relative z-10">
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden">
        <div className="flex flex-col lg:flex-row-reverse">
          <div className="lg:w-1/2 p-8 lg:p-12">
            <div className="space-y-6">
              <div className="inline-block px-3 py-1 bg-medihub-green text-medihub-primary text-sm font-medium rounded-full">
                Egészségügyi szakembereknek
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                Legyen naprakész a szakmai eseményekkel.
              </h2>
              <p className="text-lg text-gray-600">
                Regisztráljon a MediHub-ra, és első kézből értesüljön a szakmáját érintő rendezvényekről, konferenciákról és képzésekről. Bízunk benne, hogy így időben megtalálja az Önnek legmegfelelőbb eseményeket.
              </p>

              <div className="grid gap-4 md:grid-cols-2 mt-3">
                <div className="flex items-start space-x-3">
                  <div className="bg-white p-2 rounded-full">
                    <Bell className="h-5 w-5 text-medihub-primary" />
                  </div>
                  <span className="text-gray-700">Értesítések fontos eseményekről</span>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="bg-white p-2 rounded-full">
                    <CalendarDays className="h-5 w-5 text-medihub-primary" />
                  </div>
                  <span className="text-gray-700">Személyre szabott eseménynaptár</span>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="bg-white p-2 rounded-full">
                    <Hospital className="h-5 w-5 text-medihub-primary" />
                  </div>
                  <span className="text-gray-700">Szakmai kreditpontok követése</span>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="bg-white p-2 rounded-full">
                    <UserPlus className="h-5 w-5 text-medihub-primary" />
                  </div>
                  <span className="text-gray-700">Kapcsolatépítési lehetőségek</span>
                </div>
              </div>

              <div className="pt-6">
                <Link to="/register/participant" className="px-6 py-3 bg-medihub-accent text-white rounded-full font-medium hover:bg-medihub-accent/90 transition-colors shadow-lg shadow-medihub-accent/20 inline-flex items-center">
                  Ingyenes regisztráció
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 bg-medihub-primary/5 flex items-center justify-center">
            <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.7
            }} className="w-full h-full">
              <img
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=3870&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                alt="Európai egészségügyi szakember"
                className="w-full h-full object-cover"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  </section>;
};

export default HealthProfessionalCTA;
